export const HrFormat = (time) => {
    let format = time.toString().split(" ")[1]
    let hour = time.toString().split(" ")[0].split(":")[0]
    if (hour == 12) {
        let h = time.toString().split(" ")[0]
        return h
    } else {
        if (format === 'pm') {
            let hours = time.toString().split(" ")[0]
            let h = parseInt(hours.split(":")[0]) + 12
            let m = hours.split(":")[1]
            return h + ":" + m
        } else {
            if (hour < 10) {
                let ho = 0 + time.toString().split(" ")[0]
                return ho
            }
            else {
                let hourr = time.toString().split(" ")[0]
                return hourr
            }
        }
    }
}